import { Toggle } from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  HEARINGROLE_REVIEWER,
  HEARINGSTATUS_CREATED,
  HEARINGSTATUS_DRAFT,
  USERCAPACITY_EMPLOYEE,
} from '../../../../../constants/api';
import {
  allUsersInRoleByHearingIdSelector,
  hearingOwnerByHearingId,
  usersWithCapacitySelector,
} from '../../../../../features/apiFeatures/userSlice';
import {
  getAttr,
  getEntityId,
} from '../../../../../features/helpers/apiHelpers';
import {
  isReviewerPanelOpenSelector,
  isUploadingReviewersSelector,
  setIsReviewerPanelOpen,
  uploadReviewers,
} from '../../../../../features/pageFeatures/createHearingPageSlice';
import { attributeOptionsMapper } from '../../../../../utilities/mapperFunctions';
import { PeoplePickerPanel } from '../../PeoplePickerPanel';

const StakeHoldersInfoBox = ({
  hearingModel,
  updateHearingModelAttribute,
  currentHearingStatus,
}) => {
  const { t: translator } = useTranslation();
  const dispatch = useDispatch();

  const hearingId = getEntityId(hearingModel);

  const disableClosedHearingToggle =
    getAttr(currentHearingStatus, 'status') !== HEARINGSTATUS_CREATED &&
    getAttr(currentHearingStatus, 'status') !== HEARINGSTATUS_DRAFT;

  const hearingOwner = useSelector(hearingOwnerByHearingId(hearingId));
  const employees =
    useSelector(usersWithCapacitySelector(USERCAPACITY_EMPLOYEE)) || [];
  const reviewers =
    useSelector(
      allUsersInRoleByHearingIdSelector(HEARINGROLE_REVIEWER, hearingId),
    ) || [];

  const isUploadingReviewers = useSelector(isUploadingReviewersSelector);
  const isReviewerPanelOpen = useSelector(isReviewerPanelOpenSelector);

  const userItems = employees.map(
    attributeOptionsMapper('employeeDisplayName'),
  );
  const reviewerItems = reviewers.map(
    attributeOptionsMapper('employeeDisplayName'),
  );

  const onClosedHearingChange = (_, value) =>
    updateHearingModelAttribute('closedHearing', value);
  const isClosedHearingChecked = getAttr(hearingModel, 'closedHearing');
  const onClickReviewerPanel = (items) => {
    const userIds = (items || []).map((item) => item.key);
    dispatch(
      uploadReviewers({
        userIds,
        hearingId,
      }),
    );
  };

  const openReviewerPanel = () => dispatch(setIsReviewerPanelOpen(true));

  return (
    <div className="create-hearing-info-box">
      <div>
        <h3>{translator('pages.createHearing.chooseReviewersHeader')} </h3>
        <hr className="create-hearing-header-hr" />
        <button className="choose-people-link" onClick={openReviewerPanel}>
          {translator('pages.createHearing.chooseEditReviewers')}
        </button>
        <p className="people-counter">{`${translator('global.number')}: ${
          reviewers.length
        }`}</p>
      </div>
      <div>
        <hr className="create-hearing-header-hr" />
        <Toggle
          label={
            isClosedHearingChecked
              ? translator('pages.createHearing.closedHearing')
              : translator('pages.createHearing.openHearing')
          }
          inlineLabel
          onChange={onClosedHearingChange}
          checked={isClosedHearingChecked}
          disabled={disableClosedHearingToggle}
        />
      </div>
      <PeoplePickerPanel
        onClick={onClickReviewerPanel}
        isOpen={isReviewerPanelOpen}
        onClose={() =>
          isUploadingReviewers || dispatch(setIsReviewerPanelOpen(false))
        }
        userItems={userItems}
        selectedItems={reviewerItems}
        currentUserId={getEntityId(hearingOwner)}
        showSpinner={isUploadingReviewers}
        selectMultiple
        allowEmptyOnClick
        headerText={translator('pages.createHearing.chooseReviewers')}
        guideText={translator('pages.createHearing.chooseNewReviewers')}
      />
    </div>
  );
};

export { StakeHoldersInfoBox };
